export default __webpack_public_path__ + "static/media/arpeggio.109aec4a.png";